import React from 'react'

import { Pressable, Stack } from '@zet/design-system'
import { M16, R14 } from '@zet/integration-flow/components/typography'

interface SortOption {
  key: string
  displayText: string
  isDefault?: boolean
}

interface SortOptionsProps {
  options: SortOption[]
  selectedSort: string
  onSortChange: (sortKey: string) => void
}

const SORT_DESCRIPTIONS = {
  POPULARITY: 'Most popular to least popular',
  APPROVAL_CHANCE: 'High chance to low chance',
} as const

export const SortOptions: React.FC<SortOptionsProps> = ({
  options,
  selectedSort,
  onSortChange,
}) => {
  return (
    <Stack>
      {options?.map((option) => {
        // If there's a selected sort, use it; otherwise check for default
        const isSelected = selectedSort
          ? selectedSort === option.key
          : option.isDefault

        return (
          <Pressable
            key={option.key}
            className="justify-between items-center my-2 flex-row"
            onPress={() => onSortChange(option.key)}
          >
            <Stack>
              <M16>{option.displayText}</M16>
              <R14 className="text-[#24262BA6]">
                {
                  SORT_DESCRIPTIONS[
                    option.key as keyof typeof SORT_DESCRIPTIONS
                  ]
                }
              </R14>
            </Stack>

            <Stack
              className={`rounded-full h-[16px] w-[16px] items-center justify-center ${
                isSelected
                  ? 'border-[#CEA15A] border-[4px]'
                  : 'border-[#1E1A1452] border-[2px]'
              }`}
            >
              {isSelected && (
                <Stack className="bg-black rounded-full h-[10px] w-[10px]" />
              )}
            </Stack>
          </Pressable>
        )
      })}
    </Stack>
  )
}
